import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Util } from '../../../util/util';

@Component({
    selector: 'item-popover-component',
    templateUrl: 'item-popover-component.html',
    styleUrls: ['./item-popover-component.scss']
})

export class ItemPopoverComponent implements OnInit {

    @Output() onFilterSelected = new EventEmitter();

    @Input() classList;
    @Input() titulo = 'ÚLTIMOS ACESSOS';

    @Input() lista: any[] = [];

    constructor() {

    }

    ngOnInit() {
        console.log('ngOnInit -> ItemPopoverComponent');
    }

    getTextFormat(text) {
        return Util.getTextFormat(text);
    }

    selectFilter(item) {
        this.onFilterSelected.emit({
            filtro: item,
        });
    }
}
